import { type PropsWithChildren } from 'react';

import TableCell, { type THProps } from '../TableCell';

type Props = Omit<THProps, 'children' | 'head'>;

const TH: React.FC<PropsWithChildren<Props>> = ({ children, className, columnId, colSpan, label, sort }) => {
  if (sort && columnId !== undefined) {
    return (
      <TableCell head={true} label={label} columnId={columnId} sort={sort} className={className}>
        {children}
      </TableCell>
    );
  }

  return (
    <TableCell head={true} label={label} colSpan={colSpan} className={className}>
      {children}
    </TableCell>
  );
};

export default TH;
